import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    _hsq?: Array<[string, ...any[]]>;
    HubSpotConversations?: {
      widget?: {
        show: () => void;
        hide: () => void;
      };
      onReady?: (callback: () => void) => void;
    };
  }
}

export default function useHubspotTracking(): null {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname + location.search;
    const shouldHide = pathname.startsWith('/pdf');

    // Track HubSpot page view
    if (Array.isArray(window._hsq)) {
      window._hsq.push(['setPath', pathname]);
      window._hsq.push(['trackPageView']);
    }

    const toggleVisibility = (id: string, label: string) => {
      const el = document.getElementById(id);
      if (el instanceof HTMLElement) {
        if (shouldHide) {
          el.classList.add('hide-hubspot-chat');
        } else {
          el.classList.remove('hide-hubspot-chat');
        }
      }
    };

    const applyAllHidingLogic = () => {
      toggleVisibility('hubspot-messages-iframe-container', 'Chat container');
      toggleVisibility('hs-eu-cookie-confirmation', 'Cookie banner');

      const widget = window.HubSpotConversations?.widget;
      if (widget?.hide && widget?.show) {
        shouldHide ? widget.hide() : widget.show();
      }
    };

    // Apply when HubSpot is ready, or immediately
    if (typeof window.HubSpotConversations?.onReady === 'function') {
      window.HubSpotConversations.onReady(() => applyAllHidingLogic());
    } else {
      applyAllHidingLogic();
    }

    // Retry in case DOM elements load later
    const interval = setInterval(() => {
      const chatExists = document.getElementById('hubspot-messages-iframe-container');
      const cookieExists = document.getElementById('hs-eu-cookie-confirmation');

      if (chatExists || cookieExists) {
        toggleVisibility('hubspot-messages-iframe-container', 'Chat container');
        toggleVisibility('hs-eu-cookie-confirmation', 'Cookie banner');
      }

      if (chatExists && cookieExists) {
        clearInterval(interval);
      }
    }, 300);

    setTimeout(() => clearInterval(interval), 5000);
  }, [location.pathname, location.search]);

  return null;
}
